<template>
  <v-card outlined class="elevation-0">
    <div class="d-flex align-center justify-space-between">
      <v-card-title>{{ $t('autoHedge.offSetLog.title') }}</v-card-title>
      <base-button class="px-2" @click="exportCSV">{{ $t('autoHedge.offSetLog.csv') }}</base-button>
    </div>

    <base-data-table
      class="table-log"
      :items="entries"
      :headers="headers"
      hide-default-footer
    >
      <template v-slot:item.dealPrice="{ item }">
        <span style="color: #00ccff">
          {{ item.dealPrice }}
        </span>
      </template>
      <template v-slot:item.pnl="{ item }">
        <span
          class="font-weight-bold"
          :style="{ color: item.pnl.bps > 0 ? '#00ff88' : '#ff4444' }"
        >
          {{ item.pnl.label }}{{ item.pnl.pct }}% / {{ item.pnl.label
          }}{{ item.pnl.bps }}bps
        </span>
      </template>
      <template v-slot:item.csv="{ item }">
        <base-button @click="alertRow(item)">{{ $t('autoHedge.offSetLog.readRow') }}</base-button>
      </template>
    </base-data-table>
    <OffsetModal v-model="showModal" :entry="selectedEntry" isOffset="OffsetLog"/>
  </v-card>
</template>

<script>
import OffsetModal from '../../modal/OffsetModal.vue';

export default {
  components:{
    OffsetModal
  },
  data() {
    return {
      showModal : false,
      selectedEntry:null,
    };
  },
  props: ["entries"],
  computed: {
    headers() {
      return [
        { text: this.$t('autoHedge.offSetLog.headers.time'), value: "time" },
        { text: this.$t('autoHedge.offSetLog.headers.action'), value: "action" },
        { text: this.$t('autoHedge.offSetLog.headers.hedgeSize'), value: "hedgeSize" },
        { text: this.$t('autoHedge.offSetLog.headers.dealPrice'), value: "dealPrice" },
        { text: this.$t('autoHedge.offSetLog.headers.offsetAvg'), value: "offsetPrice" },
        { text: this.$t('autoHedge.offSetLog.headers.realizedPnl'), value: "pnl" },
        { text: this.$t('autoHedge.offSetLog.headers.csvFile'), value: "csv" }, //this one needs to download all
      ];
    },
  },
  methods: {
    exportCSV() {
      const csvContent =
        this.$t('autoHedge.offSetLog.csvHeaders') + "\n" +
        this.entries
          .map(
            (entry) =>
              `${entry.time}, ${entry.action}, ${entry.hedgeSize}, ${entry.dealPrice}, ${entry.offsetPrice}, ${entry.pnl}`
          )
          .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "hedge_offset_log.csv";
      a.click();

      URL.revokeObjectURL(url);
    },
    alertRow(entry) {
      this.showModal = true
      this.selectedEntry = entry
    },
  },
};
</script>

<style scoped>
.table-log {
  overflow-y: auto;
  max-height: 195px;
}

</style>
